import { Injectable } from '@angular/core';
import { PurchaseResult } from '@revenuecat/purchases-js';
import { BehaviorSubject } from 'rxjs';

import { PurchaseService } from '#services/purchase/purchase.service';
import { ToastService } from '#services/toast/toast.service';
import { logger } from '#lib/logger';
import { ISubscriptionService } from './subscription.interface';
import { ModalService } from '#services/modal/modal.service';
import { TOAST_CONFIGS } from 'src/app/shared/constants/toast-configs';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionWebService implements ISubscriptionService {
  introSubscriptionOpen$ = new BehaviorSubject<boolean>(false);

  constructor(
    private purchaseService: PurchaseService,
    private modalService: ModalService,
    private toastService: ToastService
  ) {}

  async isUserSubscribedToFullAccess(nextFn: (data: boolean) => void): Promise<void> {
    let subscribed = await this.purchaseService.checkIfUserIsSubscribed();

    if (subscribed) {
      nextFn(subscribed);
      return;
    }

    if (!subscribed && !this.introSubscriptionOpen$.value) {
      // Set the modal open state to true.
      this.setModalSubscriptionOpenState(true);

      await this.modalService.openModalIntroSubscription(async (data: PurchaseResult | null) => {
        if (data) {
          subscribed = true;

          await this.purchaseService.getCustomerInfo();

          this.toastService.showToast(TOAST_CONFIGS.subscriptionPurchased());
        }

        nextFn(subscribed);
      });
    }

    this.setModalSubscriptionOpenState(false);
  }

  /**
   * Sets the open state of the subscription modal.
   *
   * Sets the following:
   * * {@link introSubscriptionOpen$}
   *
   * @param state - A boolean indicating whether the modal should be open (`true`) or closed (`false`).
   */
  private setModalSubscriptionOpenState(state: boolean): void {
    this.introSubscriptionOpen$.next(state);

    logger.log(state, 'SubscriptionService.setModalSubscriptionOpenState -> state');
  }

  resetSubscription() {
    this.introSubscriptionOpen$.next(false);
    logger.log('complete', 'SubscriptionService.resetSubscription');
  }
}
